import { render, staticRenderFns } from "./userMessagaes.vue?vue&type=template&id=e8385274&scoped=true&"
import script from "./userMessagaes.vue?vue&type=script&lang=js&"
export * from "./userMessagaes.vue?vue&type=script&lang=js&"
import style0 from "./userMessagaes.vue?vue&type=style&index=0&id=e8385274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8385274",
  null
  
)

export default component.exports